export default {
  'datasource.targets': {
    ko: 'Target System',
    ja: 'ターゲットシステム',
    en: 'Target System',
    cn: '',
  },
  'datasource.username': {
    ko: 'Username',
    ja: 'ユーザー名',
    en: 'Username',
    cn: '',
  },
  'datasource.testconnection.success.i': {
    ko: '데이타베이스 연결에 성공하였습니다.',
    ja: 'データベースへの接続に成功しました。',
    en: 'Database connection was successful.',
    cn: '',
  },
  'datasource.name': {
    ko: '이름',
    ja: '名前',
    en: 'Stack type',
    cn: '',
  },
  'datasource.testconnection': {
    ko: '연결테스트',
    ja: '接続テスト',
    en: 'Connection test',
    cn: '',
  },
  'datasource.title.edit': {
    ko: '데이터 소스 수정',
    ja: 'データソースの変更',
    en: 'Edit datasource',
    cn: '',
  },
  'datasource.jdbcUrl': {
    ko: 'URL',
    ja: 'URL',
    en: 'URL',
    cn: '',
  },
  'datasource.maximumPoolSize': {
    ko: 'Pool size',
    ja: 'プールサイズ',
    en: 'Pool size',
    cn: '',
  },
  'datasource.title.add': {
    ko: '데이터 소스 추가',
    ja: 'データソースの追加',
    en: 'Add datasource',
    cn: '',
  },
  'datasource.password': {
    ko: 'Password',
    ja: 'パスワード',
    en: 'Password',
    cn: '',
  },
};
